import { Invitation } from './invitation';
import { User } from './user';

export enum TeammateType {
  USER = 'USER',
  INVITATION = 'INVITATION',
}

export type Teammate = User | Invitation;
